import { api } from 'api/api';
import { IAppointmentCombinedState, IFormValue } from 'models';
import { put, select, takeLatest } from 'redux-saga/effects';
import { messagingService } from 'services';
import { handleSagaError } from 'store/common';
import { actionCreator } from './slice';
import { selectors } from './selectors';
import { actionCreator as createFollowUpActionCreator } from 'store/followups/create';
import { actionCreator as closeFollowUpActionCreator } from 'store/followups/close';
import { PayloadAction } from '@reduxjs/toolkit';

export function* saga(): any {
	yield takeLatest(actionCreator.INIT_START, onInitStart);
	yield takeLatest(actionCreator.UPDATE_START, onUpdateStart);
}

function* onInitStart(action: ReturnType<typeof actionCreator.INIT_START>): any {
	try {
		const activityId: string = action.payload.activityId;
		const followUps: IAppointmentCombinedState[] = yield api.appointments.getFollowUps(activityId);
		yield put(
			actionCreator.INIT_COMPLETED({
				followUps
			})
		);
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.INIT_FAILED()]);
	}
}

function* onUpdateStart(action: ReturnType<typeof actionCreator.UPDATE_START>): any {
	try {
		const followUpResult: IFormValue<string> = yield select(selectors.form.getFollowUpResult);
		const activityId: string = yield select(selectors.getActivityId);
		const opportunityId: string = yield select(selectors.getOpportunityId);
		const followUpId: string = yield select(selectors.getFollowUpId);
		const scheduleNext = action.payload.scheduleNext;
		const onSuccess: () => PayloadAction<any> = yield select(selectors.getOnSuccess);

		// Update the follow up with the result
		yield api.followUps.completeFollowUp(followUpId, followUpResult.newValue);

		if (scheduleNext) {
			// Open create follow up dialog
			yield put(createFollowUpActionCreator.INIT_START({ activityId, opportunityId, onSuccess }));
			yield put(createFollowUpActionCreator.OPEN_DIALOG());
		} else {
			// Close opportunity logic
			yield put(closeFollowUpActionCreator.INIT_START({ activityId, opportunityId, onSuccess }));
			yield put(closeFollowUpActionCreator.OPEN_DIALOG());
		}

		messagingService.popSnackbar('Follow Up Updated', 'success');
		yield put(actionCreator.INIT_FLUSH());
		yield put(actionCreator.RESET_FORM());
		yield put(actionCreator.UPDATE_COMPLETED());
		if (onSuccess) {
			yield put(onSuccess());
		}
	} catch (error: any) {
		yield handleSagaError(error, [actionCreator.UPDATE_FAILED()]);
	}
}
